import { Spinner, SpinnerSize } from '@blueprintjs/core';
import { Icon, styled } from '@moleculeone/ui';

import { useCreditOverview } from '@f/hooks';

import { CreditConsumptionInfo } from '../credit-consumption-info/CreditConsumptionInfo';

const Container = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  whiteSpace: 'nowrap',
});

const Balance = styled('span', {
  fontWeight: 'bold',
});

export default function CreditConsumptionIndicator() {
  const creditOverview = useCreditOverview();

  if (!creditOverview) {
    return <Spinner size={SpinnerSize.SMALL} />;
  }

  const { balance } = creditOverview;

  return (
    <CreditConsumptionInfo
      triggerElement={
        <Container>
          <Icon icon="toll" />
          <div>
            <Balance>{balance.toLocaleString()}</Balance> credits available
          </div>
        </Container>
      }
    />
  );
}
